import { useLocalStorage } from 'usehooks-ts';
import { getRemainingMs } from '@app/shared/utils/countdown';

export const usePageTimer = (key: string, intervalMs: number) => {
  const [lastAt, setLastAt] = useLocalStorage<number | null>(key, null);

  const msLeft = lastAt ? getRemainingMs(lastAt, intervalMs) : null;

  const isExpired = !!lastAt && msLeft === 0;

  const trigger = () => {
    setLastAt(Date.now());
  };

  return { lastAt, trigger, isExpired, msLeft };
};
